var _path, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoom2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "room2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "inner",
    d: "M 0 0 L 64 0 L 64 34 L 34 34 L 34 64 L 0 64 Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "line1",
    x1: 0,
    x2: 0,
    y1: 64,
    y2: 0,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "line2",
    x1: 0,
    y1: 64,
    x2: 34,
    y2: 64,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "line3",
    x1: 34,
    x2: 34,
    y1: 33.01,
    y2: 64,
    stroke: "currentColor",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "line4",
    x1: 64,
    x2: 34,
    y1: 34,
    y2: 34,
    stroke: "currentColor",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "line5",
    x1: 64,
    x2: 64,
    y1: 0,
    y2: 34,
    stroke: "currentColor",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "line6",
    x1: 0,
    x2: 64,
    y1: 0,
    y2: 0,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoom2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/room2.a835a6a67e64649a5c226eeec6947383.svg";